<template>
    <section class="showcase">
    <div class="p-0 sk-margin">
        <div class="col-lg-12 order-lg-1 my-auto showcase-text">
          <h3>SUKIMATCH</h3>
          <h1 class="lead mb-0">ご利用した企業様の声</h1>
        </div>

      <div class="row no-gutters row-margin">
         <!-- Heading Row -->
    <div class="row align-items-center">
      <div class="col-lg-6">
        <img class="img-fluid service-img" src="../assets/img/sukimatch/voice1.png" alt="">
      </div>
      <!-- /.col-lg-8 -->
      <div class="col-lg-6">
        <h1 class="font-weight-light">おかげさまで繁忙期を乗り越えられました。</h1>
        <p sk-p-text>今まで他社サービスでバナー制作を手伝ってもらっていたのですが、金額面や対応時間の制約などで結局徹夜で作業ということもしばしばありました。SUKIMATCHを利用することで、24時間いつでもクリエイターに依頼できるし、費用も抑えられたので繁忙期を乗り越えることができました。本当に助かりました。</p>
    
      </div>
      <!-- /.col-md-4 -->
    </div>
      </div>
    <!-- /.row -->
         <!-- Heading Row -->
         <div class="row no-gutters row-margin">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <img class="img-fluid service-img" src="../assets/img/sukimatch/voice2.png" alt="">
      </div>
      <!-- /.col-lg-8 -->
      <div class="col-lg-6">
        <h1 class="font-weight-light">お客様にとても満足していただけました</h1>
        <p sk-p-text>馴染みのお客様から急遽大量のバナー修正依頼がきたのですが、とても社内リソースだけでは手が足りず・・・。SUKIMATCHで見つけたクリエイターさん達に手伝っていただき無事納品することができて、お客様の信頼をさらに獲得することができました！是非今後も利用していきたいです。</p>
      </div>
      <!-- /.col-md-4 -->
    </div>
         </div>
    
    <!-- /.row -->
      </div>
  </section>
</template>

<script>
export default {
    
}
</script>

<style>
.sk-margin {
    margin: 30px;
}

.row-margin {
    margin-top: 10px;
    margin-bottom: 10px;
}

.sk-p-text {
    color: #000000;
    margin-top: 20px;
}

.service-img {
    width: 70%;
    height: 70%
}

</style>